import dispatcher from '../../dispatcher';
import resizeStore from '../../resize/resize.store';
import bpStore from '../../resize/breakpoint.store';
import scrollStore from '../../scroll/scroll.store';
import colorStore from '../../color/color.store';
// import slideStore from '../../slide-scroll/slide-scroll.store';
import fontData from '../../../modules/stage/decorators/font.data';
import simpleVertexShader from '../../../modules/stage/glsl/simple.vertex.glsl';
// import simpleFragmentShader from '../../../modules/stage/glsl/simple.fragment.glsl';
import shadowFragmentShader from '../../../modules/stage/glsl/shadow.fragment.glsl';
import * as utils from '../../utils';
import { webpTest } from '../../../helpers/helpers';

let THREE, letterTexture, calcProperty;

// import * as calcProperty from '/src/assets/scripts/modules/utils/calcProperty';
// import * as THREE from '/src/assets/scripts/libs/three-r97/three.module';
// import letterTexture from '../../utils/letterTexture';

var name = 'main-shadow';
var textureLoader;
var elementCache;

var ElementCache = function() {
	this.elements = [];

	this.build = function() {
		var elements = document.getElementsByClassName('jgp');
		var self = this;

		Array.prototype.forEach.call(elements, function(el) {
			var type = el.getAttribute('data-type') ||
				el.tagName.toLowerCase();
			var texture;

			if (type === 'img') {
				texture = self.buildImgTexture(el, type);
				texture._notComplete = true;
			} else if (type === 'div') {
				texture = self.buildPlaneTexture(el, type);
			} else if (fontData.hasOwnProperty(type)) {
				texture = self.buildTextTexture(el, type);
			}

			self.elements.push({
				element: el,
				texture: texture,
				type: type
			});
		});
	}.bind(this);

	this.clear = function() {
		this.elements = [];
	}.bind(this);

	this.buildImgTexture = function(el) {
		var src = el.src;

		if (webpTest) {
			var srcset = el.srcset;
			var source = el.parentNode.querySelector('source[type="image/webp"]')

			if (source) {
				var attr = source.getAttribute('srcset');

				if (attr.length)
					src = attr;
			}

			if (srcset) {
				let srcs = srcset.replace(/\s/g, '').split(',');

				if (srcs.length)
					srcs.forEach(item => {
						if (item.indexOf('webp') >= 0)
							src = item;
					});
			}
		}

		var texture;
		texture = textureLoader.load(src, function() {
			dispatcher.dispatch({
				type: 'shadow:resize',
				element: el
			});
		});
		texture.magFilter = THREE.LinearFilter;
		texture.minFilter = THREE.LinearFilter;

		texture._size = [el.clientWidth, el.clientHeight];

		return texture;
	}.bind(this);

	this.buildPlaneTexture = function(el) {
		var texture;
		var data = new Uint8Array(3);
		var color = new THREE.Color(0xffffff);

		data[0] = color.r * 255;
		data[1] = color.g * 255;
		data[2] = color.b * 255;

		texture = new THREE.DataTexture(data, 1, 1, THREE.RGBFormat);
		texture._size = [1, 1];
		texture.needsUpdate = true;

		return texture;
	}.bind(this);

	this.buildTextTexture = function(el, type) {
		var color, text;
		var texture;

		var bpName = bpStore.getData().name;
		var font = Object.assign({}, fontData[type].default);
		if (bpName === 'wide' && !fontData[type][bpName]) {
			bpName = 'desktop'
		}

		font = Object.assign(font, fontData[type][bpName]);

		color = font.color;
		if (color === 'dynamic') {
			color = colorStore.getData().colorHex;
		}

		text = el.innerHTML;
		texture = letterTexture(text.trim(), {
			size: font.size,
			fontFamily: font.fontFamily,
			fontWeight: font.fontWeight,
			// align: 'center',
			letterSpacing: font.letterSpacing,
			color: color,
			blur: 0,
			lineHeight: font.lineHeight,
			align: 'left'
		}, {w: el.clientWidth, h: el.clientHeight}, 'linear');

		texture.needsUpdate = true;

		return texture;
	}.bind(this);

	this.handleResize = function(el) {
		var self = this;

		function resizeElement(el) {
			if (el.type === 'img') {
				if (el.texture._notComplete && el.element.complete) {
					el.texture._size = [
						el.element.clientWidth || 1,
						el.element.clientHeight || 1
					]
					el.needsUpdate = true;
					el.texture._notComplete = false;
				}
			}

			if (fontData.hasOwnProperty(el.type) && (
				el.texture._size[0] !== el.element.clientWidth ||
				el.texture._size[1] !== el.element.clientHeight
			)
			) {
				el.texture = self.buildTextTexture(el.element, el.type);
				el.texture.needsUpdate = true;
				el.needsUpdate = true;
			}
		}

		// invalidates letter textures
		if (el) {
			resizeElement(this.elements.find(function(elementData) {
				return elementData.element === el;
			}));
		} else {
			this.elements.forEach(resizeElement);
		}
	}.bind(this);

	this.getElements = function() {
		return this.elements;
	}.bind(this);
}

var WebGLClone = function(component, options) {
	this._component = component;
	this._composer = this._component._composer;
	this._options = {}
	this._scene = component._scene;

	this._meshes = [];

	this.build = function(elements) {
		var self = this;

		elements.forEach(function(elementData) {
			var geometry = new THREE.PlaneBufferGeometry(1, 1);
			var material = new THREE.ShaderMaterial({
				uniforms: {
					tDiffuse: {type: 't', value: elementData.texture},
					resolution: {type: 'v2', value: [
							elementData.element.clientWidth,
							elementData.element.clientHeight
						]},
					textureSize: {type: 'v2', value: elementData.texture._size},
					scale: {type: 'f', value: 1},
					opacity: {type: 'f', value: 1}
				},
				vertexShader: simpleVertexShader,
				fragmentShader: shadowFragmentShader,
				transparent: true
			});

			var mesh = new THREE.Mesh(geometry, material);
			mesh.position.set(0, 0, 0);
			mesh.scale.set(1, 1, 1);
			mesh.userData.elementData = elementData;

			calcProperty.attach(elementData.element, {
				namespace: 'main-shadow'
			});
			elementData.element._calcProperty.subscribeGlobal(function() {
				self.calcMeshPosition(mesh);
			});

			self._scene.add(mesh);
			self._meshes.push(mesh);
		});

		this._composer.needsUpdate = true;
		this.handleResize();
	}.bind(this);

	this.clear = function() {
		var self = this;
		this._meshes.forEach(function(mesh) {
			mesh.geometry.dispose();
			mesh.material.dispose();
			self._scene.remove(mesh);
		});
		this._meshes = [];
	}.bind(this);

	this.calcMeshPosition = function(mesh) {
		var size = this._component._renderer.getSize(new THREE.Vector2());
		var ww = size.width;
		var wh = size.height;
		var scrolled = scrollStore.getData().top;

		var elementData = mesh.userData.elementData;
		var box = elementData.box;

		var x, y;
		var addX, addY, addOpacity;

		if (!box) return;

		addX = elementData.element._calcProperty.getGlobal({
			property: 'x'
		});
		addY = elementData.element._calcProperty.getGlobal({
			property: 'y'
		});
		addOpacity = elementData.element._calcProperty.getGlobal({
			property: 'opacity'
		});

		x = (box.left + addX) - ww / 2 + box.width / 2;
		y = -((box.top + addY) - scrolled - wh / 2 + box.height / 2);

		mesh.userData.height = box.height;
		mesh.userData.width = box.width;
		mesh.userData.left = box.left;
		mesh.userData.top = box.top;

		if (mesh.position.x !== x ||
			mesh.position.y !== y ||
			mesh.scale.x !== box.width ||
			mesh.scale.y !== box.height ||
			mesh.material.uniforms.opacity.value || addOpacity) {
			this._composer.needsUpdate = true;
		}

		mesh.position.set(x, y, 0);
		mesh.scale.set(box.width || 1, box.height || 1, 1);
		mesh.material.uniforms.resolution.value = [box.width, box.height];
		mesh.material.uniforms.opacity.value = addOpacity;
	}.bind(this);

	this.handleResize = function(element) {
		var self = this;

		function resizeMesh(mesh) {
			var elementData = mesh.userData.elementData;
			var offset = utils.offset(elementData.element);
			var ot = offset.top;
			var ol = offset.left;
			var h = elementData.element.clientHeight;
			var w = elementData.element.clientWidth;

			elementData.box = {
				width: w,
				height: h,
				left: ol,
				top: ot
			}

			self.calcMeshPosition(mesh);

			if (elementData.needsUpdate) {
				elementData.needsUpdate = false;

				mesh.material.uniforms.tDiffuse.value = elementData.texture;
				mesh.material.uniforms.textureSize.value = elementData.texture._size;
			}
		}

		if (element) {
			resizeMesh(this._meshes.find(function(mesh) {
				return mesh.userData.elementData.element === element;
			}));
		} else {
			this._meshes.forEach(resizeMesh);
		}

		this._composer.needsUpdate = true;
	}.bind(this);

	this.handleScroll = function() {
		var self = this;
		var scrolled = scrollStore.getData().top;
		var size = this._component._renderer.getSize(new THREE.Vector2());
		var ww = size.width;
		var wh = size.height;

		this._meshes.forEach(function(mesh) {
			var ot = mesh.userData.top;
			var h = mesh.userData.height;

			var y = -(ot - scrolled - wh / 2 + h / 2);

			mesh.position.setY(y);
		});

		this._composer.needsUpdate = true;
	}.bind(this);
}

var attach = function(component, options) {
	var decorator;

	if (!component._decorators) {
		component._decorators = {};
	}
	if (!component._decorators[name]) {
		component._decorators[name] = new WebGLClone(component, options);
	}
	decorator = component._decorators[name];

	Promise
	.all([
		import(/* webpackPrefetch: true */ '/src/assets/scripts/libs/three-r97/three.module'),
		import(/* webpackPrefetch: true */ '/src/assets/scripts/modules/utils/calcProperty'),
		import(/* webpackPrefetch: true */ '/src/assets/scripts/modules/utils/letterTexture'),
	]).then(([a, b, c]) => {
		THREE = a;
		calcProperty = b;
		letterTexture = c.default;

		textureLoader = new THREE.TextureLoader();
		THREE.Cache.enabled = true;

		elementCache = new ElementCache();
		elementCache.build();
		decorator.build(elementCache.getElements());

		window.addEventListener('load', function() {
			elementCache.handleResize();
			decorator.handleResize();
		});

		dispatcher.subscribe(function(e) {
			var loadedImgs, totalImgs;
			var imgs = utils.onScreen('img.jgp');

			if (e.type === 'content:replaced') {
				setTimeout(function() {
					loadedImgs = 0;
					totalImgs = imgs.length;

					if (!imgs.length) {
						dispatcher.dispatch({
							type: 'page-transition:check',
							step: 2
						});
					} else {
						imgs.forEach(function(img) {
							var t = textureLoader.load(img.src, function() {
								loadedImgs++;

								if (loadedImgs >= totalImgs) {
									dispatcher.dispatch({
										type: 'page-transition:check',
										step: 2
									});

									elementCache.handleResize();
									decorator.handleResize();
								}
							});
						});
					}

					elementCache.clear();
					elementCache.build();
					decorator.clear();
					decorator.build(elementCache.getElements());
				}, 0);
			}

			if (e.type === 'resize:soft-resize') {
				elementCache.handleResize();
				decorator.handleResize();
			}

			if (e.type === 'shadow:resize') {
				elementCache.handleResize(e.element);
				decorator.handleResize(e.element);
			}
		});

		resizeStore.subscribe(elementCache.handleResize);
		scrollStore.subscribe(decorator.handleScroll);
		resizeStore.subscribe(decorator.handleResize);
	});

	return decorator;
}

var detach = function(component, options) {
	resizeStore.unsubscribe(elementCache.handleResize);
	scrollStore.unsubscribe(decorator.handleScroll);
	resizeStore.unsubscribe(decorator.handleResize);
}

export default {
	attach: attach,
	detach: detach
};